<template>
  <div>
    <form-table style="padding: 0; margin-top: 10px">
      <template slot="table">
        <v-data-table
            ref="table"
            :headers="colunas"
            :items="itens"
            :server-items-length="totalItens"
            :options.sync="paginacaoInterna"
            :loading="false"
            no-data-text="Não há serviços registrados para o filtro."
            class="table-list"
            hide-default-footer>
          <template #item.titulo="{ item }">
            <MolensTooltip max-width="300px">
              <span class="d-inline-block text-truncate max-text">{{ item.titulo | textoSemValor }}</span>
              <template #content>
                {{ item.descricao | textoSemValor }}
              </template>
            </MolensTooltip>
          </template>
          <template #item.valor="{item}">
            <span>{{ item.valor | valorParaReal }}</span>
          </template>
          <template #item.acoes="{item}">
            <v-tooltip top v-if="permiteSelecionar">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="tratarEventoSelecionar(item)" icon>
                  <v-icon color="primary">fas fa-check</v-icon>
                </v-btn>
              </template>
              Selecionar serviço
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="tratarEventoEditar(item)" icon class="ml-2">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              Editar serviço
            </v-tooltip>
          </template>
        </v-data-table>
      </template>
    </form-table>
  </div>
</template>

<script>
import FormTable from '@/views/components/FormTable.vue'
import MolensTooltip from '@/views/components/MolensTooltip.vue'

export default {
    name: 'ServicosTabela',
    components: {MolensTooltip, FormTable},
    props: {
        itens: Array,
        paginacao: Object,
        totalItens: Number,
        permiteSelecionar: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            colunas: [
                {
                    text: 'Título',
                    value: 'titulo',
                    sortable: false,
                    align: 'left',
                    width: '50%',
                    class: 'gray--text'
                },
                {
                    text: 'Valor',
                    value: 'valor',
                    sortable: false,
                    align: 'left',
                    width: '25%',
                    class: 'gray--text'
                },
                {
                    text: '',
                    value: 'acoes',
                    sortable: false,
                    align: 'right',
                    width: '25%',
                    class: 'gray--text'
                }
            ],
            paginacaoInterna: this.paginacao
        }
    },
    methods: {
        tratarEventoEditar(item) {
            this.$emit('editarItem', item)
        },
        tratarEventoSelecionar(item) {
            this.$emit('selecionarItem', item)
        }
    },
}
</script>


<style scoped lang="stylus">
.max-text
  max-width 10vw

@media (max-width: 720px)
  .max-text
    max-width 40vw !important
</style>